import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import { connect } from 'react-redux'
import iconNew from '../../../assets/icons/new-light.svg'
import Pagination from '../../../components/pagination/pagination.component'
import './permissions.styles.scss'
import Service from './permissions.service'
import { FormatDate } from '../../../utils/UIHelper'
import Filters from './filters.component'
import iconDelete from '../../../assets/icons/delete-red.svg'
import iconEdit from '../../../assets/icons/edit-dark.svg'
import DeletePermission from './components/delete/delete.component'

class Permissions extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadPermissions()
    }

    onPageChange = page => {
        this.setState({
            ...this.state,
            currentPage: page
        }, () => this.service.loadPermissions())
    }

    onFilterChange = e => {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                value: "",
                [e.target.name]: e.target.value
            }
        })
    }

    onFilterSubmit = e => {
        e.preventDefault()
        this.service.loadPermissions()
    }

    toggleShowDelete = permission => this.setState({
        ...this.state,
        showDelete: !this.state.showDelete,
        permissionToDelete: permission
    })

    onDelete = () => this.setState({
        ...this.state,
        showDelete: false,
        permissions: this.state.permissions.filter(permission => permission.id !== this.state.permissionToDelete.id)
    })

    render() {
        return (
            <>
                {this.state.loadingPermissions && <Dialog><Loading /></Dialog>}
                {this.state.showDelete && <Dialog><DeletePermission permission={this.state.permissionToDelete} onDelete={this.onDelete} onCancel={() => this.toggleShowDelete(null)} /></Dialog>}
                <div className="permissions">
                    <div className="header">
                        <h4>Permissions</h4>
                        <div className="buttons">
                            <Filters onChange={this.onFilterChange} onSubmit={this.onFilterSubmit} {...this.state.filter}/>
                            <Link className="btn" to="/security/permission/create"><img alt="" src={iconNew} />New Permission</Link>
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Group</th>
                                <th>Created</th>
                                <th>Updated</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.permissions.map((permission, key) => <tr key={key}>
                                    <td>{permission.name}</td>
                                    <td>{permission.group}</td>
                                    <td>{FormatDate(permission.created * 1000)}</td>
                                    <td>{FormatDate(permission.updated * 1000)}</td>
                                    <td>
                                        <div className="actions">
                                            <img alt="" src={iconEdit} onClick={() => this.props.history.push('/security/permission/' + permission.id)} />
                                            <img alt="" src={iconDelete} onClick={() => this.toggleShowDelete(permission)} />
                                        </div>
                                    </td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                    {
                        this.state.total > 0 && <Pagination totalItemsCount={this.state.total} currentIndex={this.state.currentPage} itemsPerPage={this.state.pageSize} onChange={this.onPageChange} />
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Permissions))